import { Route, Routes } from 'react-router-dom';
import FinanceManagement from '../../Pages/FinanceManagement/FinanceManagement.Page';
import FinanceUpdateNotice from '../../Pages/FinanceManagement/FinanceUpdateNotice';

function FinanceManagementRoute() {
    return (
        <Routes>
            <Route index element={<FinanceUpdateNotice />} />
        </Routes>
    );
}

export default FinanceManagementRoute;
